var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column"},[_c('h5',[_vm._v("Total Return Per Hour")]),_c('div',{attrs:{"id":"singleScatter"}})])}]

export { render, staticRenderFns }